import { useState, useEffect } from 'react';
import { supabase } from './supabase';

export function useUnreadMessages(userId) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    // Initial fetch
    const fetchUnreadCount = async () => {
      try {
        const { count, error } = await supabase
          .from('messages')
          .select('*', { count: 'exact', head: true })
          .eq('receiver_id', userId)
          .eq('is_read', false)
          .is('deleted_at', null);

        if (error) {
          console.error('Error fetching unread messages:', error);
        } else {
          setUnreadCount(count || 0);
        }
      } catch (error) {
        console.error('Failed to fetch unread messages:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUnreadCount();

    // Realtime subscription
    const channel = supabase
      .channel(`unread-messages-${userId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'messages',
          filter: `receiver_id=eq.${userId}`
        },
        () => {
          // Refetch on any change
          fetchUnreadCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId]);

  return { unreadCount, loading };
}
